import { Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Popup } from '@/components';
import { ShowRecentThreads, ShowUserThreads } from './ShowThreads';
import { Chat } from './Chat';
import Loader from '@/components/common/Loader';
import { Header } from './Header';
import { Footer } from './Footer';

import './MessagesPopup.css';
import { ChatWindow } from './ChatWindow';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { ctxMessages } from '@/contexts/MessagesCtx';

function Body() {
  const ctx = useContext(ctxMessages);
  if (isPhoneOrHighScreen() && ctx?.thread) {
    return <Chat key={ctx.thread.threadId} />;
  }
  if (!ctx) return;
  return (
    <div className="chat-targets">
      <Suspense fallback={<Loader />}>
        {ctx.searchText && ctx.searchText.length > 2 ? (
          <ShowUserThreads name={ctx.searchText} key={ctx.searchText} />
        ) : (
          <ShowRecentThreads />
        )}
      </Suspense>
    </div>
  );
}

export default function MessagesPopup({ closePopup }: { closePopup: () => Promise<void> }) {
  const { t } = useTranslation();
  const ctx = useContext(ctxMessages);

  if (!ctx) return;

  const popupTitle = ctx.thread ? undefined : t('mainMenu.messages');
  const header = <Header />;
  const body = <Body />;
  const footer = <>{ctx.thread && <Footer />}</>;

  if (isPhoneOrHighScreen()) {
    return (
      <Popup
        popupTitle={popupTitle}
        header={header}
        body={body}
        footer={footer}
        closePopup={closePopup}
        isFullScr={true}
        showCloseButton={false}
        leftText={true}
      />
    );
  }

  return (
    <>
      <div className="thread-list-container">
        {header}
        {body}
      </div>
      <ChatWindow />
    </>
  );
}
